import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {forkJoin, Observable} from 'rxjs';
import {MessagesService} from 'app/layout/common/messages/messages.service';
import {NavigationService} from 'app/core/navigation/navigation.service';
import {NotificationsService} from 'app/layout/common/notifications/notifications.service';
import {UserService} from 'app/core/user/user.service';
import {AccountRole} from '@enums/AccountRole';

@Injectable({
    providedIn: 'root'
})
export class InitialDataResolver  {
    /**
     * Constructor
     */
    constructor(
        private readonly _messagesService: MessagesService,
        private readonly _navigationService: NavigationService,
        private readonly _notificationsService: NotificationsService,
        private readonly _userService: UserService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        const _user = JSON.parse(localStorage.getItem('user') ?? '');

        if (_user.rol === AccountRole.master || _user.rol === AccountRole.semiMaster) {
            // Fork join multiple API endpoint calls to wait all of them to finish
            return forkJoin([
                this._navigationService.get(),
                this._messagesService.getAll(),
                this._userService.get()
            ]);
        } else {
            // Fork join multiple API endpoint calls to wait all of them to finish
            return forkJoin([
                this._navigationService.get(),
                this._messagesService.getAll(),
                this._notificationsService.getAll(),
                this._userService.get()
            ]);
        }
    }
}
